import { useContext } from "react";
import { Close } from "@radix-ui/react-dialog";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faTrashCan } from "@fortawesome/free-regular-svg-icons";
import { faTrashCan as faSolidTrashCan } from "@fortawesome/free-solid-svg-icons";
import { useRevokeAccountMutation } from "../../../../api/hooks/useRevokeAccountMutation.ts";
import { Button, LinkButton, Modal } from "../../../../components";
import { DataContext } from "../../../../dataProviders/DataProvider.tsx";
import css from "./DeleteAccount.module.css";
import { useToast } from "../../../../components/Toast/useToast.ts";
import { t, Trans } from "@lingui/macro";

export function DeleteAccount() {
  const revokeAccount = useRevokeAccountMutation();
  const { storage } = useContext(DataContext);
  const { showToast } = useToast();
  const deleteAccount = async () => {
    try {
      await revokeAccount.mutateAsync();
      window.location.reload();
    } catch (e) {
      showToast({ variant: "attention", title: t`Smazat účet se nepodařilo`, description: t`Zkuste to znovu.` });
    }
  };
  return (
    <Modal
      title={t`Smazat veškerá data a přístupy`}
      icon={
        <FontAwesomeIcon className={css.icon} icon={faSolidTrashCan} width={"22px"} height={"22px"} color={"#d92d20"} />
      }
      trigger={
        <LinkButton
          className={css.dropdownItem}
          variant={"destructive"}
          color={"secondary"}
          size={"md"}
          endIcon={<FontAwesomeIcon icon={faTrashCan} width={20} height={20} />}
        >
          <Trans>Smazat data a přístupy</Trans>
        </LinkButton>
      }
    >
      <p className={css.modalText}>
        <Trans>Opravdu chcete smazat veškerá data, přístupy a resetovat účet?</Trans>
      </p>
      <p className={css.modalText}>
        <Trans>Účet lze znovu aktivovat "Obnovením hesla".</Trans>
      </p>

      <div className={css.buttonGroup}>
        <Close asChild>
          <Button variant={"default"} color={"gray"} size={"md"}>
            <Trans>Zavřít</Trans>
          </Button>
        </Close>

        <Button
          variant={"destructive"}
          color={"primary"}
          size={"md"}
          endIcon={<FontAwesomeIcon icon={faSolidTrashCan} />}
          onClick={() => {
            void deleteAccount();
            storage?.clearStoredValue();
          }}
        >
          <Trans>Smazat</Trans>
        </Button>
      </div>
    </Modal>
  );
}
